import React, { useState, useEffect } from 'react';

// Species-specific activity config
const ACTIVITIES = {
  capybara: {
    emoji: '♨️',
    altEmojis: ['💧', '🍊', '🌸'],
    bgColor: 'bg-[#FDF0D5]',
    messages: [
      'Njuter av sitt bad… stör inte 💦',
      '*flyter lyckligt* 🛁',
      'Zzz… spa-tid ♨️',
      'Jag återhämtar mig, fokusera du ✨',
    ],
    idleClass: 'animate-pet-bob',
  },
  corgi: {
    emoji: '💤',
    altEmojis: ['💤', '😴', '🦴'],
    bgColor: 'bg-[#FFC8DD]',
    messages: [
      'Zzz… stör mig inte medan jag sover 💤',
      '*pyttesnarkning* 🐾',
      'Jag tjuvsover, jobba du på',
      'Drömmer om godis — Corgus zzz',
    ],
    idleClass: 'animate-pet-sleep',
  },
  red_panda: {
    emoji: '🧶',
    altEmojis: ['🧶', '🍵', '🌿'],
    bgColor: 'bg-[#B9FBC0]',
    messages: [
      'Jag stickar — stör inte mig 🧶',
      'Tyst tid, jobba du på…',
      '*mysfika* 🍵',
      'Koncentrerar mig — du också!',
    ],
    idleClass: 'animate-pet-bob',
  },
  frog: {
    emoji: '🧘',
    altEmojis: ['💮', '🪷', '✨'],
    bgColor: 'bg-[#A2D2FF]',
    messages: [
      'Mediterar… schh 🧘',
      'I zen-zonen — stör inte',
      'Djup andning. Jobba du, jag är här.',
      '*lugnt plopp* 🪷',
    ],
    idleClass: 'animate-pet-float',
  },
};

const DEFAULT = ACTIVITIES.corgi;

export default function FocusPetActivity({ pet, isRunning, isWork }) {
  const [msgIndex, setMsgIndex] = useState(0);

  useEffect(() => {
    if (!isRunning || !isWork) return;
    const interval = setInterval(() => {
      setMsgIndex((i) => i + 1);
    }, 12000);
    return () => clearInterval(interval);
  }, [isRunning, isWork]);

  if (!pet || !isRunning || !isWork) return null;

  const activity = ACTIVITIES[pet.pet_type] || DEFAULT;
  const message = activity.messages[msgIndex % activity.messages.length];

  return (
    <div className={`neo-card p-4 ${activity.bgColor} mt-4 relative overflow-hidden`} data-testid="focus-pet-activity">
      <div className="flex items-center gap-3 relative z-10">
        {/* Pet sprite area */}
        <div className="relative flex-shrink-0">
          <div className={`w-20 h-20 rounded-full border-[3px] border-black overflow-hidden shadow-[3px_3px_0px_0px_rgba(0,0,0,1)] ${activity.idleClass}`}>
            <img src={pet.image} alt={pet.name} className="w-full h-full object-cover" />
          </div>

          {/* Floating Zzz / activity emoji — 3 staggered copies */}
          <span
            className="absolute -top-3 -right-2 text-2xl opacity-90 animate-float-up"
            style={{ animationDelay: '0s' }}
          >
            {activity.emoji}
          </span>
          <span
            className="absolute -top-1 right-6 text-lg opacity-80 animate-float-up"
            style={{ animationDelay: '1.5s' }}
          >
            {activity.altEmojis[0]}
          </span>
          <span
            className="absolute top-3 -left-3 text-base opacity-70 animate-float-up"
            style={{ animationDelay: '3s' }}
          >
            {activity.altEmojis[1] || activity.emoji}
          </span>
        </div>

        <div className="flex-1 min-w-0">
          <p className="text-[10px] font-bold uppercase tracking-wider opacity-60 mb-0.5">
            {pet.name} just nu
          </p>
          <p className="font-bold text-sm leading-tight transition-opacity duration-500" key={message}>
            {message}
          </p>
        </div>
      </div>

      {/* Subtle background sparkle */}
      <div className="absolute inset-0 pointer-events-none opacity-30">
        <span className="absolute top-2 right-8 text-xs animate-pulse-soft">✨</span>
        <span className="absolute bottom-3 left-24 text-xs animate-pulse-soft" style={{ animationDelay: '1s' }}>✨</span>
      </div>
    </div>
  );
}
